// Copyright 2017-2026 @polkadot/apps authors & contributors
// SPDX-License-Identifier: Apache-2.0

// setup these right at front
import './initBufferHack.js';
import 'semantic-ui-css/semantic.min.css';
import '@polkadot/react-components/i18n';
import '@polkadot/api-augment/substrate';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { isG1Available, loadNetworkConfig } from '@polkadot/apps-config';

import { fetchG1GenesisHash } from './g1GenesisService.js';

async function main () {
  const rootId = 'root';
  const rootElement = document.getElementById(rootId);

  if (!rootElement) {
    throw new Error(`Unable to find element with id '${rootId}'`);
  }

  // Phase 1: Discover G1 genesis hash (max 5s, non-blocking on failure)
  await fetchG1GenesisHash();

  // Phase 2: Load network configs in parallel
  const promises: Promise<unknown>[] = [];

  if (!localStorage.getItem('networkConfig-gdev')) {
    promises.push(loadNetworkConfig('gdev'));
  }

  if (!localStorage.getItem('networkConfig-gtest')) {
    promises.push(loadNetworkConfig('gtest'));
  }

  if (isG1Available() && !localStorage.getItem('networkConfig-g1')) {
    promises.push(loadNetworkConfig('g1'));
  }

  if (promises.length > 0) {
    try {
      await Promise.all(promises);
    } catch (error) {
      console.error('Failed to load network configuration', error);
    }
  }

  // --- Nouvelle logique pour choisir le meilleur endpoint ---
  const { getBestApiUrl } = await import('./getBestApiUrl.js');
  const { settings } = await import('@polkadot/ui-settings');
  const bestApiUrl = await getBestApiUrl();
  settings.set({ apiUrl: bestApiUrl });

  // Dynamically import the rest of the app
  await import('./initSettings.js');

  const { default: Root } = await import('./Root.js');
  const { ApolloWrapper } = await import('./ApolloWrapper.js');

  createRoot(rootElement).render(
    <ApolloWrapper>
      <Root isElectron={false} />
    </ApolloWrapper>
  );
}

main().catch(console.error);

export { squidClient } from './squidClient.js';
export * from './squidQueries.js';
